import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { pdfParts, Images, DateOptions } from '../designHelp/pdfCreate';
import { DateUtilities } from 'app/shared/utilities/dateUtilities';

@Component({
  selector: 'app-pdf-item',
  templateUrl: './pdf-item.component.html',
  styleUrls: ['./pdf-item.component.css']
})
export class PdfItemComponent implements OnInit, OnChanges {

  @Input() item: pdfParts;
  @Output() itemChange = new EventEmitter<pdfParts>();
  @Input() language;
  @Input('pos') position: PdfItemPosition;
  @Input() level: number;
  @Input() images :Array<Images>;
  @Output('move') moveInArray = new EventEmitter()
  @Output('changes') change = new EventEmitter<pdfParts>();
  @Output('something') something = new EventEmitter<pdfParts>();
  @Output('remove') remove = new EventEmitter();
  @Output('hover') hover = new EventEmitter();

  expandedState = false;
  itemMode = 'content';
  tableChoice = { x: 0, y: 0 }
  imageExists:boolean = true;
  conditionChoices = [
    { key:'includeProductPage', value:'Produkt side'},
    { key:'showProductLines', value:'Vis produkter'},
    { key: 'showHours', value: 'Vis timer' },
    { key: 'offerDisclaimerIsEmpty', value: 'Hvis uden forbehold' },
    { key: 'offerDescriptionIsEmpty', value: 'Hvis uden beskrivelse' },
    { key: 'customerAndDeliveryAddressSame', value:'Kunde-/Leveranseadresse er samme'},
    { key: 'noDeliveryAddress', value:'Savner leveranseadresse'},
    { key: 'noRequisitionNumber', value:'Inget rekvisitionsnummer'},
    { key: 'noReference', value:'Ingen reference'}
  ]
  dynamicTextChoices = [
    { key: 'companyName', value: 'Firma navn' },
    { key: 'companyAddress', value: 'Firma adresse' },
    { key: 'companyZipCode', value: 'Firma postnr.' },
    { key: 'companyZipCity', value: 'Firma postnr. og by' },
    { key: 'companyCity', value: 'Firma by' },
    { key: 'companyPhone', value: 'Firma telefon' },
    { key: 'companyEmail', value: 'Firma email' },
    { key: 'companyWebPage', value: 'Firma hjemmeside' },
    { key: 'companyVAT', value: 'Firma CVR' },
    { key: 'companyAddressSingle', value: 'Firma oplysninger linje' },
    { key: 'companyAddressStack', value: 'Firma oplysninger liste' },
    { key: 'disabled', value: '-------------------' },
    { key: 'customerNumber', value: 'Kundenummer' },
    { key: 'customerName', value: 'Kunde navn' },
    { key: 'customerAddress', value: 'Kunde adresse' },
    { key: 'customerZipCode', value: 'Kunde postnr.' },
    { key: 'customerZipCity', value: 'Kunde postnr. og by' },
    { key: 'customerCity', value: 'Kunde by' },
    { key: 'customerPhone', value: 'Kunde telefon' },
    { key: 'customerMobile', value: 'Kunde mobil' },
    { key: 'customerEmail', value: 'Kunde email' },
    { key: 'customerVAT', value: 'Kunde CVR' },
    { key: 'customerAddressStack', value: 'Kunde oplysninger liste' },
    { key: 'disabled', value: '-------------------' },
    { key: 'customerDeliveryName', value: 'Kunde leveranse navn' },
    { key: 'customerDeliveryAddress', value: 'Kunde leveranse adresse' },
    { key: 'customerDeliveryZipCode', value: 'Kunde leveranse postnr.' },
    { key: 'customerDeliveryZipCity', value: 'Kunde leveranse postnr. og by' },
    { key: 'customerDeliveryCity', value: 'Kunde leveranse by' },
    { key: 'customerDeliveryPhone', value: 'Kunde leveranse telefon' },
    { key: 'customerDeliveryEmail', value: 'Kunde leveranse email' },
    { key: 'customerDeliveryAddressStack', value: 'Kunde leveranse oplysninger liste' },
    { key: 'disabled', value: '-------------------' },
    { key: 'customerInvoiceName', value: 'Kunde faktura navn' },
    { key: 'customerInvoiceAddress', value: 'Kunde faktura adresse' },
    { key: 'customerInvoiceZipCode', value: 'Kunde faktura postnr.' },
    { key: 'customerInvoiceZipCity', value: 'Kunde faktura postnr. og by' },
    { key: 'customerInvoiceCity', value: 'Kunde faktura by' },
    { key: 'customerInvoicePhone', value: 'Kunde faktura telefon' },
    { key: 'customerInvoiceEmail', value: 'Kunde faktura email' },
    { key: 'customerInvoiceAddressStack', value: 'Kunde faktura oplysninger liste' },
    { key: 'disabled', value: '-------------------' },
    { key: 'contactName', value: 'Kunde kontakt navn' },
    { key: 'contactAddress', value: 'Kunde kontakt adresse' },
    { key: 'contactZipCode', value: 'Kunde kontakt postnr.' },
    { key: 'contactZipCity', value: 'Kunde kontakt postnr. og by' },
    { key: 'contactCity', value: 'Kunde kontakt by' },
    { key: 'contactPhone', value: 'Kunde kontakt telefon' },
    { key: 'contactEmail', value: 'Kunde kontakt email' },
    { key: 'contactAddressStack', value: 'Kunde kontakt oplysninger liste' },
    { key: 'offerNumber', value: 'Tilbudsnummer' },
    { key: 'variationNumber', value: 'Aftalenummer' },
    { key: 'offerDate', value: 'Tilbud dato' },
    { key: 'offerTitle', value: 'Tilbuds titel' },
    { key: 'offerDescription', value: 'Tilbud beskrivelse' },
    { key: 'offerDisclaimer', value: 'Tilbud forbehold' },
    { key: 'offerResponsible', value: 'Tilbud ansvarlig' },
    { key: 'offerResponsibleTitle', value: 'Tilbud ansvarlig titel' },
    { key: 'offerResponsibleInitials', value: 'Tilbud ansvarlig initialer' },
    { key: 'offerResponsibleCountryCode', value: 'Tilbud ansvarlig landskode' },
    { key: 'offerResponsiblePhone', value: 'Tilbud ansvarlig telefon' },
    { key: 'offerResponsibleEmail', value: 'Tilbud ansvarlig email' },
    { key: 'offerTotalExVat', value: 'Tilbud total ekskl.' },
    { key: 'offerTotalIncVat', value: 'Tilbud total inkl.' },
    { key: 'offerTotalVAT', value: 'Tilbud total moms' },
    { key: 'offerWorkHours', value: 'Tilbud timantal' },
    { key: 'requisitionNumber', value: 'Tilbud rekvisitionsnummer' },
    { key: 'ourReference', value: 'Vores reference' },
    { key: 'disabled', value: '-------- Kun i header, footer--------' },
    { key: '[currentPage]', value: 'sidenummer' },
    { key: '[pageCount]', value: 'total sider' }
  ];
  bsConfig = DateUtilities.bsConfig;
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(c: SimpleChanges) {
    
    if (!!this.item && !!this.position && !this.item.position) {
      this.item['position'] = { index: this.position.index, level: this.level }
    }
    if(this.item.type == 'productPage' && !this.item.pageBreak) this.item.pageBreak = 'before';
    if(this.item.type == 'image' && this.item.image != 'logo') {
      this.imageExists = !!this.images.find(x => x.name == this.item.image);
    }
  }

  onSimpleChange() {
    this.something.emit(this.item)
    console.log(this.item.translates)
  }

  async changeSpotInArray(array, oldIndex, newIndex) {
    let item = array[oldIndex];
    array.splice(oldIndex, 1);
    array.splice((oldIndex + newIndex), 0, item)
    return array
  }

  move(delta) {
    this.moveInArray.emit(delta)
  }

  async moveChild(i, event){
    this.item.columns = await this.changeSpotInArray(this.item.columns, i, event);
    this.reportChange()
  }

  async reportChange() {
    await this.itemChange.emit(this.item)
    await this.change.emit(this.item)
}

  removeMe() {
    this.remove.emit(true)
  }

  async typeChange(event) {
   switch (event.target.value) {
     case ('columns'): {
       this.item['type'] = 'columns';
       if (!this.item.columns) {
        this.item['columns'] = [{ name: '1', type: null }, { name: '2', type: null }];
       }
       break
      }
     case ('stack'): {
       this.item['type'] = 'stack';
       if (!this.item.columns) {
        this.item['columns'] = [{ name: '1', type: null }, { name: '2', type: null }];
       }
       ; break
     }
     case ('table'): {
       this.item['type'] = 'table';
       this.item['tableType'] = 'horizontal';
       this.item['headers'] = 1;
       this.item['tableWidths'] = [0, 0];
       this.item['tableRows'] = [
         [{ name: 'new', type: 'text', textType: 'free', text: 'Text' }, { name: 'new', type: 'text', textType: 'free', text: 'Text' }],
         [{ name: 'new', type: 'text', textType: 'free', text: 'Text' }, { name: 'new', type: 'text', textType: 'free', text: 'Text' }]
       ];
       ; break
     }
     case ('text'): {
       this.item['type'] = 'text';
       this.item['text'] = 'Text '
       this.item['textType'] = 'free';
       ; break
     }
     case ('image'): {
       this.item.type = 'image';
       this.item['image'] = 'logo';
       this.item['fit'] = [100, 100];
       ; break
     }
     case ('line'): {
       this.item = {
         name:'Line',
         type: 'line'
       }
       ; break
     }
     case ('sumTotal'): {
       this.item = { name: 'Sum', type: 'sumTotal', totalType: 'normal' };
       break
     }
     case ('productPage'): {
       this.item = {
         name: 'Product page',
         type: 'productPage'
       };
       break
     }
     case ('productTable'): {
       this.item = {
         name: 'Produkt tabel',
         type: 'productTable',
         translates: {
           amount: 'Antal',
           pricePer: 'Pris / st.',
           text: 'Tekst',
           discount: 'Rabat',
           price: 'Pris',
           hourPlusStartUp: 'Arbejdstider + Opstartsgebyr',
           productNumber: 'Produktnummer',
           useArticleNumber: false,
           hideAllPrices: false
         }
       }; break
     }
     case ('compositeText'): {
       this.item.type = 'compositeText';
       if (!this.item.columns) {
         this.item['columns'] = [
           {
             name: '1',
             type: 'text',
             text: 'text',
             textType: 'free'
           },
           {
             name: '2',
             type: 'text',
             text: 'text',
             textType: 'free'
           }
         ]
       }
       ; break
     }
     case ('absolute'):{
       this.item = {
         name: this.item.name,
         type: 'absolute',
         fit: [200, 200],
         singleItem: { type: 'text', name: 'text', text: 'fixed text' + this.level, textType: 'free', bold: true, fontSize:15 },
         text: this.level == 1 ? 'absolutePosition' : 'relativePosition'
       };
       break
     }
     case ('link'): {
       this.item = {
         name: this.item.name,
         type: 'link',
         link: ''

       };
       break
     }
     case ('date'): {
       this.item['type'] = 'date';
       this.item['dateSettings'] = new DateOptions();
       this.item['variable'] = '';
       this.item.dateSettings.language = this.language;
       break
     }
     case (null): {
       this.item = {type:'text', name:'text', text:'', textType:'free'}
        ; break
      }
   }
   //await this.removeUnusableProperties();
    this.onSimpleChange()
  }

  removeUnusableProperties() {
    if (!!this.item.columns && this.item.type != 'columns' && this.item.type != 'stack') {
      delete this.item.columns
    }
    if (!!this.item.image && this.item.type != 'image') {
      delete this.item.image;
      delete this.item.fit;
    }
    if (!!this.item.tableType && this.item.type != 'table') {
      delete this.item.tableType;
      delete this.item.tableRows;
      delete this.item.tableWidths;
      delete this.item.headers;
      delete this.item.lineWidth;
    }
  }

  addTableColumn() {
    for (let row of this.item.tableRows) {
      row.push({ name: 'new', textType:'free', type: 'text', text:'text' })
    }
    this.item.tableWidths.push(0);
    this.onSimpleChange();
  }

  removeTableColumn(i) {
    for (let row of this.item.tableRows) {
      row = row.splice(i,1)
    }
    this.item.tableWidths.splice(i,1);
    this.onSimpleChange();
  }

  addTableRow() {
    let newRow = []
    for (var t = 0; t < this.item.tableRows[0].length; t++) {
      newRow.push({name:'new', textType:'free',type:'text', text:'text'})
    }
    this.item.tableRows.push(newRow);
    this.onSimpleChange();
  }

  addFont(value) {
    if (!!this.item.font) { this.item.font = value }
    else { this.item['font'] = value }
    if ((!value || value == 'null') && this.item.font) {
      delete this.item.font;
    }
    this.onSimpleChange()
  }

  log(e) {
    console.log(e)
  }

  addTableType(event) {
    if (event == '' && !!this.item.tableType) { delete this.item.tableType }
    if (event == 'none') { !!this.item.tableType ? this.item.tableType = 'none' : this.item['tableType'] = 'none' }
    if (event == 'header') { !!this.item.tableType ? this.item.tableType = 'header' : this.item['tableType'] = 'header' }
    if (event == 'horizontal') { !!this.item.tableType ? this.item.tableType = 'horizontal' : this.item['tableType'] = 'horizontal' }
    this.onSimpleChange();
  }

  addCondition() {
    this.item['condition'] = 'none'
  }

  removeCondition() {
    this.item['condition'] = null;
    delete this.item['condition'];
    
  }

  changeImage(image) {
    console.log(this.item, image)
    this.item = { name: image.name, type: 'image', image: image.name, fit: [100, 100] }
    this.reportChange();
    this.onSimpleChange()
  }

  deleteFakeLine() {
    delete this.item.translates.fakeDifferenceLine;
    this.onSimpleChange();
  }

  changePageBreak(e:Event){
    e.preventDefault();
    let t = e.target as HTMLInputElement;
    if(this.item.pageBreak == 'none') this.item['pageBreak'] = 'before';
    else this.item.pageBreak = 'none';
    this.onSimpleChange();
  }

  tester(value) {
    console.log(this.item, value)
  }

  changeDate(ev:Date){
    if(ev) this.item.dateSettings.variable = ev.toISOString();
  }

 async setTableWidth(amount, index){
    this.item.tableWidths[index] = +amount;
    this.onSimpleChange();
  }
}

export class PdfItemPosition {
  index: number;
  length: number;
}
